import { themeSpaces } from '../../../../theme/foundations';
var sheetMaxHeight = "100vh - ".concat(themeSpaces.l);
var menuListPaddingY = "".concat(themeSpaces.s, " * 2");
var titleHeight = '36px';
var titleAndGapHeight = "".concat(titleHeight, " - ").concat(themeSpaces.xs);
export var _mobileMenuDropdownTheme = {
  baseStyle: _ref => {
    var {
      hasTitle,
      hasItems
    } = _ref;
    return {
      menuList: {
        paddingTop: !hasItems ? 'none' : 's',
        paddingBottom: 's'
      },
      title: {
        display: 'flex',
        alignItems: 'center',
        paddingX: 'm',
        height: titleHeight
      },
      items: {
        overflowY: 'auto',
        maxHeight: "calc(".concat(sheetMaxHeight, " - ").concat(menuListPaddingY, " - ").concat(hasTitle ? titleAndGapHeight : '0px', ")")
      }
    };
  }
};
//# sourceMappingURL=_MobileMenuDropdown.theme.js.map